import { Button, FileUpload, FormField } from "@wix/design-system";
import React, { useContext, useMemo } from "react";
import { EditorContext, RicosContext } from "./../../ricos-context";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common";
import { Uploader } from "./../../plugin-commons";
import { RICOS_DEFAULTS } from "../constants";
import { UPLOAD_TAB_UPLOAD_BUTTON } from "../dataHooks";
import { VIDEO_TYPE } from "../types";
import { VideoPluginService } from "./videoPluginService";
const FILE_INPUT_ACCEPT = "video/*";
const UploadVideo = ({
  nodeId,
  helpers,
  enableCustomUploadOnMobile,
  uploadService,
  updateService,
  closeModal,
  disableDownloadDefault,
  handleFileSelection,
  handleFileUpload
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const hasCustomFileUpload = Boolean(handleFileUpload || handleFileSelection);
  const showUploadSection = (!isMobile || enableCustomUploadOnMobile) && hasCustomFileUpload;
  const videoPluginService = useMemo(
    () => new VideoPluginService({ disableDownloadDefault }),
    [disableDownloadDefault]
  );
  const handleUploadClick = () => {
    helpers?.onPluginsPopOverClick?.({
      pluginId: VIDEO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.upload
    });
    if (handleFileSelection) {
      handleFileSelection(
        handleExternalFileChange(nodeId, getEditorCommands(), updateService, videoPluginService)
      );
      closeModal();
      return;
    }
    uploadService?.selectFiles(
      FILE_INPUT_ACCEPT,
      false,
      handleNativeFileChange(
        nodeId,
        getEditorCommands(),
        uploadService,
        new Uploader(handleFileUpload),
        videoPluginService
      )
    );
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(FormField, { label: t("VideoCustomUploadModal_Title"), maxLines: 2 }, showUploadSection ? /* @__PURE__ */ React.createElement(FileUpload, { onChange: () => {
  }, accept: FILE_INPUT_ACCEPT }, () => /* @__PURE__ */ React.createElement(
    Button,
    {
      dataHook: UPLOAD_TAB_UPLOAD_BUTTON,
      onClick: handleUploadClick,
      fullWidth: true,
      size: "small"
    },
    t("VideoUploadModal_CustomVideoClickText")
  )) : null);
};
const handleExternalFileChange = (nodeId, editorCommands, updateService, videoPluginService) => ({ data }) => {
  const id = nodeId || editorCommands.insertBlockWithBlankLines(VIDEO_TYPE, RICOS_DEFAULTS);
  const file = data instanceof Array ? data[0] : data;
  queueMicrotask(() => {
    updateService?.updatePluginData({ data: file }, id, VIDEO_TYPE, videoPluginService);
  });
};
const handleNativeFileChange = (nodeId, editorCommands, uploadService, uploader, videoPluginService) => (files) => {
  const id = nodeId || editorCommands.insertBlockWithBlankLines(VIDEO_TYPE, RICOS_DEFAULTS);
  const file = files instanceof Array ? files[0] : files;
  queueMicrotask(() => {
    uploadService.uploadFile(
      new File([file], file.name, { type: file.type }),
      id,
      uploader,
      VIDEO_TYPE,
      videoPluginService
    );
  });
};
export {
  UploadVideo
};
//# sourceMappingURL=upload-video.js.map
